<mic-spinner-overlay id="workorders-details-spinner-overlay" ariaLabel="In Progress" color="primary" [loading]="loading">
  @if (breadcrumbItems.length > 0) {
  <mic-breadcrumb id="workorders-details-breadcrumb">
    @for (crumb of breadcrumbItems; track crumb) { @if (!$last) {
    <mic-breadcrumb-link
      [link]="crumb.link"
      [icon]="crumb.icon"
      [label]="translationService.translate(crumb.labelKey || crumb.label)"
      [ariaLabel]="translationService.translate(crumb.labelKey || crumb.label)"
    ></mic-breadcrumb-link>
    } @if ($last) {
    <mic-breadcrumb-link
      [label]="translationService.translate(crumb.labelKey || crumb.label)"
      [ariaLabel]="translationService.translate(crumb.labelKey || crumb.label)"
    ></mic-breadcrumb-link>
    } }
  </mic-breadcrumb>
  }
  <div class="flex flex-row justify-between align-items-center wo-title-container">
    <h3 class="mt-1" id="workorders-details-title">{{ translationService.translate('workOrderDetailsText') }}</h3>
    <div class="flex flex-row justify-end" style="align-items: center">
      @if (canEditFields) {
      <mic-status id="required-fields-status" class="primary" style="margin-right: 50px">{{
        translationService.translate('requiredFieldsLabelText')
      }}</mic-status>
      }
      <button id="back-button" mat-flat-button style="margin-right: 14px; margin-top: 2px" (click)="backNavigation()">
        <mat-icon>arrow_back</mat-icon>
        <span>{{ translationService.translate('backButtonText') }}</span>
      </button>
      @if (isManualReleasedEnabled){
      <button
        id="released-wo-button"
        mat-flat-button
        (click)="onWorkOrderReleasedClick()"
        style="margin-right: 14px; margin-top: 2px"
        [disabled]="!isWorkOrderReleasedEnabled"
      >
        <mat-icon>save</mat-icon>
        <span>{{ translationService.translate('releaseWOText') }}</span>
      </button>
      <button
        id="released-selected-wol-button"
        mat-flat-button
        (click)="onSelectedWOLReleasedClick()"
        style="margin-right: 14px; margin-top: 2px"
        [disabled]="!isSelectedWOLEnabled"
      >
        <mat-icon>save</mat-icon>
        <span>{{ translationService.translate('releaseSelectedWOLText') }}</span>
      </button>
      }
      <button
        id="save-button"
        type="button"
        style="margin-right: 14px; margin-top: 2px"
        mat-flat-button
        color="primary"
        class="mic-btn-icon-left"
        (click)="saveChanges()"
        [disabled]="!canEditFields || loading"
      >
        <mat-icon>save</mat-icon>
        <span>{{ translationService.translate('saveLinkText') }}</span>
      </button>
      @if (isCreateWorkOrderEnabled) {
      <span
        [matTooltip]="hasUnsavedHeaderChanges ? `${translationService.translate('addLineToolTipText')}` : ''"
        matTooltipPosition="below"
        [matTooltipDisabled]="false"
      >
        <button
          id="add-bulk-lines-button"
          type="button"
          style="margin-right: 14px; margin-top: 2px"
          mat-flat-button
          color="primary"
          class="mic-btn-icon-left"
          (click)="openAddBulkLines()"
          [disabled]="!canEditFields || loading || hasUnsavedHeaderChanges"
        >
          <mat-icon>note_add</mat-icon>{{ translationService.translate('addBulkWorkOrderLineText') }}
        </button>
      </span>
      <span
        [matTooltip]="hasUnsavedHeaderChanges ? `${translationService.translate('addLineToolTipText')}` : ''"
        matTooltipPosition="below"
        [matTooltipDisabled]="false"
      >
        <button
          id="add-line-button"
          type="button"
          style="margin-right: 14px; margin-top: 2px"
          mat-flat-button
          color="primary"
          class="mic-btn-icon-left"
          (click)="openAddLine()"
          [disabled]="!canEditFields || loading || hasUnsavedHeaderChanges"
        >
          <mat-icon>note_add</mat-icon>{{ translationService.translate('addLineButtonText') }}
        </button>
      </span>
      }

      <button id="export-button" mat-flat-button color="primary" style="margin-right: 14px; margin-top: 2px" (click)="openExportModal()">
        <mat-icon>download</mat-icon>
        <span>{{ translationService.translate('exportText') }}</span>
      </button>
      @if (isDeleteWorkOrderEnabled) {
      <span
        [matTooltip]="!canDeleteSelection() ? translationService.translate('notEligibleToDeleteText') : ''"
        [matTooltipDisabled]="canDeleteSelection()"
      >
        <button id="bulk-delete-button" type="button" mat-flat-button color="warn" (click)="onDelete()" [disabled]="!canDeleteSelection()">
          <mat-icon class="work-order-delete-icon">delete</mat-icon>
          <span>{{ translationService.translate('deleteText') }}</span>
        </button>
      </span>
      }
    </div>
  </div>

  <mat-accordion id="work-order-line-details-accordion">
    <mat-expansion-panel id="work-order-header-panel" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ translationService.translate('workOrderHeaderText') }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form id="work-order-header-form" [formGroup]="workOrderHeaderForm">
        <!-- First Row: Basic Work Order Information -->
        <div class="filter-container mt-3">
          <mat-form-field
            id="work-order-number-field"
            subscriptSizing="dynamic"
            class="filter-item mat-form-field-required"
            [ngClass]="canEditFields ? 'edit-component' : 'view-component'"
          >
            <mat-label>{{ translationService.translate('workOrderNumberText') }}</mat-label>
            <input
              id="work-order-number-input"
              matInput
              type="text"
              formControlName="workOrderNumber"
              [readonly]="!canEditFields"
              maxlength="10"
            />
            @if ( workOrderHeaderForm.get('workOrderNumber')?.hasError('required') && (workOrderHeaderForm.get('workOrderNumber')?.touched
            || workOrderHeaderForm.get('workOrderNumber')?.dirty) ) {
            <mat-error id="work-order-number-error">
              {{ translationService.translate('selectAtleastOneValueErrorText') }}
            </mat-error>
            }
          </mat-form-field>
          <mat-form-field id="work-order-status-field" subscriptSizing="dynamic" class="filter-item view-component">
            <mat-label>{{ translationService.translate('workOrderStatusText') }}</mat-label>
            <!-- Display translated status label while keeping the underlying form control as the status code -->
            <input
              id="work-order-status-input"
              matInput
              type="text"
              [value]="getTranslatedStatus(workOrder?.workOrderStatus || workOrderHeaderForm.get('workOrderStatus')?.value)"
              readonly
            />
          </mat-form-field>
          @if (!canEditFields) {
          <mat-form-field id="plant-view-field" subscriptSizing="dynamic" class="filter-item view-component">
            <mat-label>{{ translationService.translate('plantText') }}</mat-label>
            <input id="plant-input-text" matInput type="text" formControlName="plant" readonly />
          </mat-form-field>
          } @else {
          <div
            class="filter-item mat-form-field-required edit-component"
            [ngClass]="{ 'plant-error-highlight': workOrderHeaderForm.get('plant')?.hasError('incorrect') }"
          >
            <mic-dropdown-search
              micDropdownAccessibility
              id="plant-input-dropdown"
              formControlName="plant"
              [data]="plantNamesList"
              [widthConfig]="{ width: '100%' }"
              placeholder="{{ translationService.translate('selectPlantText') }}"
              label="{{ translationService.translate('plantText') }}"
              searchPlaceholder="Search"
              subscriptSizing="dynamic"
              [multiple]="false"
            >
            </mic-dropdown-search>
            @if ( workOrderHeaderForm.get('plant')?.hasError('required') && (workOrderHeaderForm.get('plant')?.touched ||
            workOrderHeaderForm.get('plant')?.dirty) ) {
            <div class="mat-error-wrapper">
              <mat-error id="plant-error">
                {{ translationService.translate('selectAtleastOneValueErrorText') }}
              </mat-error>
            </div>
            }
          </div>
          } @if (!canEditFields) {
          <mat-form-field id="site-view-field" subscriptSizing="dynamic" class="filter-item view-component">
            <mat-label>{{ translationService.translate('siteText') }}</mat-label>
            <input id="site-input-text" matInput type="text" formControlName="site" readonly />
          </mat-form-field>
          } @else {
          <div class="filter-item mat-form-field-required edit-component">
            <mic-dropdown-search
              micDropdownAccessibility
              id="site-input-dropdown"
              formControlName="site"
              [data]="siteNamesList"
              [widthConfig]="{ width: '100%' }"
              placeholder="{{ translationService.translate('selectSiteText') }}"
              label="{{ translationService.translate('siteText') }}"
              searchPlaceholder="Search"
              subscriptSizing="dynamic"
              [multiple]="false"
            >
            </mic-dropdown-search>
            @if ( workOrderHeaderForm.get('site')?.hasError('required') && (workOrderHeaderForm.get('site')?.touched ||
            workOrderHeaderForm.get('site')?.dirty) ) {
            <div class="mat-error-wrapper">
              <mat-error id="site-error">
                {{ translationService.translate('selectAtleastOneValueErrorText') }}
              </mat-error>
            </div>
            }
          </div>
          } @if (!canEditFields) {
          <mat-form-field id="salesman-view-field" subscriptSizing="dynamic" class="filter-item view-component">
            <mat-label>{{ translationService.translate('salesIdText') }}</mat-label>
            <input
              id="salesman-input-text"
              matInput
              type="text"
              [value]="getSalesmanDisplay(workOrderHeaderForm.get('salesman')?.value)"
              readonly
            />
          </mat-form-field>
          } @else {
          <div class="filter-item edit-component">
            <mic-dropdown-search
              micDropdownAccessibility
              id="salesman-input-dropdown"
              formControlName="salesman"
              [data]="salesmen"
              [widthConfig]="{ width: '100%' }"
              placeholder="{{ translationService.translate('salesIdText') }}"
              label="{{ translationService.translate('salesIdText') }}"
              searchPlaceholder="{{ translationService.translate('SearchText') }}"
              subscriptSizing="dynamic"
              [attribute]="'login'"
              [multiple]="false"
            >
            </mic-dropdown-search>
          </div>
          }

          <mat-form-field
            id="received-date-field"
            subscriptSizing="dynamic"
            class="filter-item mat-form-field-required"
            [ngClass]="[
              receiveDtEdit && canEditFields ? 'edit-component' : 'view-component',
              workOrderHeaderForm.get('receivedDate')?.hasError('backDateLimit') ? 'plant-error-highlight' : ''
            ]"
          >
            <mat-label>
              {{ translationService.translate('receivedDateText') }}
            </mat-label>
            <input
              id="received-date-input"
              matInput
              [placeholder]="dateFormatService.currentFormat"
              [matDatepicker]="receivedDatePicker"
              formControlName="receivedDate"
              [readonly]="!receiveDtEdit || !canEditFields"
              [min]="receivedDatePickerOpened ? minDate : null"
              autocomplete="off"
            />
            <!--          <input matInput type="text" formControlName="receivedDate" readonly />-->
            <mat-datepicker-toggle
              id="received-date-picker-toggle"
              matSuffix
              [for]="receivedDatePicker"
              [disabled]="!receiveDtEdit || !canEditFields"
            ></mat-datepicker-toggle>
            <mat-datepicker
              #receivedDatePicker
              [disabled]="!receiveDtEdit || !canEditFields"
              (opened)="onReceivedDatePickerOpened()"
              (closed)="onReceivedDatePickerClosed()"
            ></mat-datepicker>
            @if ( workOrderHeaderForm.get('receivedDate')?.hasError('required') && (workOrderHeaderForm.get('receivedDate')?.touched ||
            workOrderHeaderForm.get('receivedDate')?.dirty) ) {
            <mat-error id="received-date-error">
              {{ translationService.translate('selectAtleastOneValueErrorText') }}
            </mat-error>
            } @if (workOrderHeaderForm.get('receivedDate')?.hasError('backDateLimit')) {
            <mat-error id="received-date-back-date-limit-error">
              {{ translationService.translate('dueDatePastErrorText').replace('-', (dealer?.woBackDtLimit ?? 30).toString()) }}
            </mat-error>
            }
          </mat-form-field>
          <mat-form-field
            id="due-date-field"
            subscriptSizing="dynamic"
            class="filter-item mat-form-field-required"
            [ngClass]="[
              canEditFields ? 'edit-component' : 'view-component',
              workOrderHeaderForm.get('dueDate')?.hasError('weekendNotAllowed') ||
              workOrderHeaderForm.get('dueDate')?.hasError('matDatepickerMin') ||
              workOrderHeaderForm.get('dueDate')?.hasError('matDatepickerMax')
                ? 'plant-error-highlight'
                : ''
            ]"
          >
            <mat-label>{{ translationService.translate('dueDateText') }}</mat-label>
            <input
              id="due-date-input"
              matInput
              [placeholder]="dateFormatService.currentFormat"
              [matDatepicker]="backgroundPicker"
              formControlName="dueDate"
              [min]="minDueDate"
              [max]="maxDueDate"
              [matDatepickerFilter]="dueDateFilter"
              [readonly]="!canEditFields"
              autocomplete="off"
            />
            <!--          <input matInput type="text" formControlName="dueDate" readonly />-->
            <mat-datepicker-toggle
              id="due-date-picker-toggle"
              matSuffix
              [for]="backgroundPicker"
              [disabled]="!canEditFields"
            ></mat-datepicker-toggle>
            <mat-datepicker #backgroundPicker [disabled]="!canEditFields"></mat-datepicker>
            @if ( workOrderHeaderForm.get('dueDate')?.hasError('required') && (workOrderHeaderForm.get('dueDate')?.touched ||
            workOrderHeaderForm.get('dueDate')?.dirty) ) {
            <mat-error id="due-date-error">
              {{ translationService.translate('selectAtleastOneValueErrorText') }}
            </mat-error>
            } @if (isDueDateLessThanReceivedDateFromForm()) {
            <mat-error id="due-date-on-or-before-received-date-error">
              {{ translationService.translate('dueDateOnOrBeforeReceivedDateText') }}
            </mat-error>
            } @if ( workOrderHeaderForm.get('dueDate')?.hasError('weekendNotAllowed') && (workOrderHeaderForm.get('dueDate')?.touched ||
            workOrderHeaderForm.get('dueDate')?.dirty) ) {
            <mat-error id="due-date-weekend-not-allowed-error">{{
              translationService.translate('dueDateWeekendNotAllowedText')
            }}</mat-error>
            } @if ( workOrderHeaderForm.get('dueDate')?.hasError('matDatepickerMin') && !isDueDateLessThanReceivedDateFromForm() &&
            (workOrderHeaderForm.get('dueDate')?.touched || workOrderHeaderForm.get('dueDate')?.dirty) ) {
            <mat-error id="due-date-min-error">
              {{ translationService.translate('dueDateTurnaroundErrorText').replace('-', getTurnaroundTime().toString()) }}
            </mat-error>
            } @if ( workOrderHeaderForm.get('dueDate')?.hasError('matDatepickerMax') && (workOrderHeaderForm.get('dueDate')?.touched ||
            workOrderHeaderForm.get('dueDate')?.dirty) ) {
            <mat-error id="due-date-max-error">
              {{ translationService.translate('dueDateFutureErrorText').replace('-', (dealer?.dueDateOverrideLimit ?? 0).toString()) }}
            </mat-error>
            }
          </mat-form-field>
          @if (showDueDayField) {
          <mat-form-field id="due-day-field" subscriptSizing="dynamic" class="filter-item view-component">
            <mat-label>{{ translationService.translate('dueDayText') }}</mat-label>
            <input id="due-day-input" matInput type="text" formControlName="dueDay" readonly />
          </mat-form-field>
          }
        </div>
        <!-- Second Row: Dates and Customer Information -->
        <div class="filter-container">
          <div class="filter-item">
            <span
              [matTooltip]="!canEditFields ? translationService.translate('cannotModifyCustomerWhileInProgressText') : ''"
              matTooltipPosition="below"
            >
              <button
                id="search-customer-button"
                mat-flat-button
                class="mic-btn-icon-left"
                style="height: 48px; width: 90%; margin-top: 4px"
                (click)="openCustomerModal()"
                type="button"
                [disabled]="!canEditFields"
              >
                <mat-icon>search</mat-icon>
                <span>{{ translationService.translate('searchCustomerText') }}</span>
              </button>
            </span>
          </div>

          <!-- CUSTOMER CODE: editable with debounced lookup (mirrors createworkorder) -->
          <mat-form-field
            id="customer-code-field"
            subscriptSizing="dynamic"
            class="filter-item"
            [ngClass]="canEditFields ? 'edit-component' : 'view-component'"
          >
            <mat-label>{{ translationService.translate('customerCodeText') }}</mat-label>
            <input
              id="customer-code-input"
              matInput
              type="text"
              formControlName="customerCode"
              autocomplete="off"
              [readonly]="!canEditFields"
              [matTooltip]="!canEditFields ? translationService.translate('cannotModifyCustomerWhileInProgressText') : ''"
              matTooltipPosition="below"
            />
            @if ( workOrderHeaderForm.get('customerCode')?.hasError('required') && (workOrderHeaderForm.get('customerCode')?.touched ||
            workOrderHeaderForm.get('customerCode')?.dirty) ) {
            <mat-error id="customer-code-error">
              {{ translationService.translate('selectAtleastOneValueErrorText') }}
            </mat-error>
            } @if (customerCodeLookupLoading) {
            <mat-spinner matSuffix diameter="18"></mat-spinner>
            } @if (workOrderHeaderForm.get('customerCode')?.hasError('lookupFailed')) {
            <mat-error id="customer-code-lookup-error">{{ workOrderHeaderForm.get('customerCode')?.getError('lookupFailed') }}</mat-error>
            }
          </mat-form-field>

          <!-- CUSTOMER NAME: converted to text input -->
          <mat-form-field id="customer-name-field" subscriptSizing="dynamic" class="filter-item2x view-component">
            <mat-label>{{ translationService.translate('customerNameText') }}</mat-label>
            <input id="customer-name-input" matInput type="text" formControlName="customerName" autocomplete="off" readonly tabindex="-1" />
            @if ( workOrderHeaderForm.get('customerName')?.hasError('required') && (workOrderHeaderForm.get('customerName')?.touched ||
            workOrderHeaderForm.get('customerName')?.dirty) ) {
            <mat-error id="customer-name-error">
              {{ translationService.translate('selectAtleastOneValueErrorText') }}
            </mat-error>
            }
          </mat-form-field>

          <mat-form-field
            id="crn-field"
            subscriptSizing="dynamic"
            class="filter-item"
            [ngClass]="canEditFields ? 'edit-component' : 'view-component'"
          >
            <mat-label>{{ translationService.translate('CRNText') }}</mat-label>
            <input id="crn-input" matInput type="text" formControlName="crn" [readonly]="!canEditFields" maxlength="20" />
            @if ( workOrderHeaderForm.get('crn')?.hasError('required') && (workOrderHeaderForm.get('crn')?.touched ||
            workOrderHeaderForm.get('crn')?.dirty) ) {
            <mat-error id="crn-mandatory-error">{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field id="number-of-lines-field" subscriptSizing="dynamic" class="filter-item view-component">
            <mat-label>{{ translationService.translate('totalLineNumberText') }}</mat-label>
            <input id="number-of-lines-input" matInput type="text" formControlName="numberOfLines" readonly />
          </mat-form-field>

          @if (custCodeReqValue && custCodeReqValue !== 'N') {
          <mat-form-field id="fiscal-id-num-field" subscriptSizing="dynamic" class="filter-item view-component">
            <mat-label>{{ translationService.translate(custCodeFieldLabelKey) }}</mat-label>
            <input id="fiscal-id-num-input" matInput type="text" formControlName="fiscalIdNum" placeholder="-" readonly />
            @if ((custCodeReqValue === 'R') && workOrderHeaderForm.get('fiscalIdNum')?.hasError('required') &&
            workOrderHeaderForm.get('fiscalIdNum')?.touched) {
            <mat-error id="fiscal-id-num-error">{{ translationService.translate('requiredFieldText') }}</mat-error>
            }
          </mat-form-field>
          }
        </div>

        <div class="filter-container">
          <mat-form-field id="customer-note-field" subscriptSizing="dynamic" class="filter-item3x view-component">
            <mat-label>{{ translationService.translate('customerNotesText') }}</mat-label>
            <input id="customer-note-input" matInput type="text" formControlName="customerNote" readonly />
          </mat-form-field>
        </div>
      </form>
      <!--  </mat-card>-->
    </mat-expansion-panel>
  </mat-accordion>
  <!-- Keep modals inside overlay to ensure z-index and visibility -->
  <mic-modal id="weekend-modal" #weekendModal></mic-modal>

  <ng-template #weekendConfirmation>
    <p>{{ translationService.translate('dueDateWeekendText') }}</p>
  </ng-template>

  <!-- CUSTOMER MODAL and template (modalPlantId is set at open time in TS) -->
  <mic-modal id="customer-modal" #customerModal></mic-modal>
  <ng-template #customerModalContent>
    <mic-customer-select-model
      id="customer-select-model"
      [dealerId]="dealer?.id"
      [userLogin]="userLogin"
      [plantId]="modalPlantId"
      [activeOnly]="true"
      [customerTypes]="['Customer', 'AssociateDealer']"
      (result)="onCustomerSelected($event)"
    >
    </mic-customer-select-model>
  </ng-template>

  <!-- UNSAVED CHANGES MODAL -->
  <ng-template #unsavedConfirmation>{{ this.translationService.translate('unSaveChangesText') }}</ng-template>
  <mic-modal id="unsaved-changes-modal" class="modalC" #unsavedChangesModal></mic-modal>
  <app-work-order-line-list
    #workOrderLineList
    id="work-order-line-list"
    [refreshWolList]="refreshWolList"
    [workOrderId]="workOrderId"
    (fetchComplete)="onWolListFetchComplete()"
  ></app-work-order-line-list>

  <app-bulk-wo-modal
    #bulkWoModal
    [plant]="modalPlant"
    [selectedCustomerUuid]="modalCustomerUuid"
    [headerSettings]="headerSettings"
    [existingLines]="[]"
    [productionCustomers]="productionCustomers"
    [preferredTreadSpecPk]="preferredTreadSpecPk"
    (linesAdded)="onBulkLinesAdded($event)"
  >
  </app-bulk-wo-modal>

  <app-wo-line-modal
    #woLineModal
    [plant]="modalPlant"
    [selectedCustomerUuid]="modalCustomerUuid"
    [customerRtDot]="customerRtDot"
    [customerTreadDepth]="customerReqTreadDepth"
    [customerDisposalChargesFk]="customerDisposalChargesFk"
    [headerSettings]="headerSettings"
    [productionCustomers]="productionCustomers"
    [preferredTreadSpecPk]="preferredTreadSpecPk"
    [addingLineToExistingWo]="true"
    [currentLineNo]="getNextLineNumber()"
    [rememberBrand]="customerRememberBrand"
    [rememberCasingNote]="customerRememberCasingNote"
    (lineAdded)="onLineAdded($event)"
  >
  </app-wo-line-modal>
</mic-spinner-overlay>
